module.exports = __webpack_public_path__ + "assets/generatepress.a14c86a2.svg";